import { render } from "./ProdutosSelecionados.vue?vue&type=template&id=208d0e3f"
import script from "./ProdutosSelecionados.vue?vue&type=script&lang=js"
export * from "./ProdutosSelecionados.vue?vue&type=script&lang=js"

import "./ProdutosSelecionados.vue?vue&type=style&index=0&id=208d0e3f&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QBtn,QInput,QPagination});
